import clsx from "clsx";

import { SubmissionModel, BusinessType } from "@interfaces/index";
import { formatAmount } from "@utils/index";
import { SubmissionStatus } from "@components/index";

export const TableTdMobileSubmission = ({
  submission,
  puEnabled,
  businessType,
  disabled,
  onClickRow,
}: {
  submission: SubmissionModel;
  puEnabled: boolean;
  businessType?: BusinessType;
  disabled?: boolean;
  onClickRow: () => void;
}) => (
  <tr
    className={clsx(disabled && "bg-black-8 opacity-40")}
    data-testid="tr_submissionsTable"
    onClick={() => !disabled && onClickRow()}
  >
    <td className="rounded-lg border border-black-8 px-4 pb-4 pt-2">
      <div className="flex justify-between">
        <div className="pt-2 capitalize text-black-54">
          {submission.period.title}
        </div>
        <SubmissionStatus status={submission.status} />
      </div>
      <div className="flex pt-2 font-bold capitalize text-black-100">
        {submission.userBusiness.name}
      </div>
      <div className="flex items-end justify-between pt-6">
        <div>
          <div className="text-100 text-black-54">Profit/Loss</div>
          <div
            className={clsx(
              "pt-0.5 text-300 font-bold",
              submission.profit[0] === "-"
                ? "text-black-100"
                : "text-green-100",
            )}
          >
            {formatAmount(submission.profit)}
          </div>
        </div>
        <div className="flex items-end gap-x-6">
          {puEnabled && (
            <div className="flex flex-col items-end">
              <div className="text-100 text-black-54">Private</div>
              <div className="font-bold text-black-100">
                {formatAmount(submission.private)}
              </div>
            </div>
          )}
          <div className="flex flex-col items-end">
            <div className="max-w-14 text-100 text-black-54">
              {businessType !== "landlord" && "Business "}Expenses
            </div>
            <div className="font-bold text-black-100">
              {formatAmount(submission.business)}
            </div>
          </div>
          <div className="flex flex-col items-end">
            <div className="text-100 text-black-54">Income</div>
            <div className="font-bold text-green-100">
              {formatAmount(submission.income)}
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
);
